import { render, staticRenderFns } from "./MessageTable.vue?vue&type=template&id=3554f4e9&scoped=true&"
import script from "./MessageTable.vue?vue&type=script&lang=js&"
export * from "./MessageTable.vue?vue&type=script&lang=js&"
import style0 from "./MessageTable.vue?vue&type=style&index=0&id=3554f4e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3554f4e9",
  null
  
)

export default component.exports